// src/frontend/.../Recruitment/validation/section3.js
import errorTrackerV2 from "./Utils/ErrorTrackerV2";
import readDataS3 from "../../../../../backend/Recruitment/Sections/Section3/readDataS3";
const isBlank = (v) =>
  v === null || v === undefined || (typeof v === "string" && v.trim() === "");

export async function validateSection3(data = {}) {
  // console.log("\n=== Section 3 Validation Started ===");
  // console.log("Input data from component:", data);

  // Check if we received empty workHistory from component
  const componentWorkHistory = Array.isArray(data?.workHistory)
    ? data.workHistory
    : [];

  if (componentWorkHistory.length === 0) {
    // console.warn(
    //   "WARNING: Component passed empty workHistory, fetching directly from Firebase...",
    // );

    try {
      const firebaseData = await readDataS3();
      // console.log("Direct Firebase fetch result:", firebaseData);

      if (!firebaseData || !firebaseData.workHistory) {
        // console.error("ERROR: No work history data in Firebase");
        const formErrors = {
          dataNotFound: "No work history data found in database.",
        };
        const tracked = { workHistory: [], ...formErrors, _isValid: false };
        errorTrackerV2.setSectionErrors("section3", tracked);
        return tracked;

      }

      // Convert Firebase object to array using direct index access
      const rawWorkHistory = firebaseData.workHistory || {};
      // console.log("Raw workHistory from Firebase:", rawWorkHistory);

      const workHistoryArray = [];
      for (let i = 0; i < 10; i++) {
        if (rawWorkHistory[i]) {
          // console.log(`Found entry at index ${i}:`, rawWorkHistory[i]);
          workHistoryArray.push(rawWorkHistory[i]);
        }
      }

      // console.log(
      //   "Converted workHistory array length:",
      //   workHistoryArray.length,
      // );

      if (workHistoryArray.length === 0) {
        // console.error("ERROR: Could not convert Firebase data to array");
        const formErrors = {
          dataNotFound: "Could not process work history data.",
        };
        const tracked = { workHistory: [], ...formErrors, _isValid: false };
        errorTrackerV2.setSectionErrors("section3", tracked);
        return tracked;

      }

      // Use the fetched data instead of component data
      data = { ...data, workHistory: workHistoryArray };
      // console.log("Using direct Firebase data for validation");
    } catch (error) {
      //  console.error("ERROR fetching from Firebase:", error);
      const formErrors = {
        dataNotFound: "Error loading work history data.",
      };
     const tracked = { workHistory: [], ...formErrors, _isValid: false };
     errorTrackerV2.setSectionErrors("section3", tracked);
     return tracked;

    }
  }

  const formData = data || {};

  // If data is null, all required fields are missing
  if (data === null || data === undefined) {
    const formErrors = {
      dataNotFound:
        "No data found for this section. Please open and save it first.",
    };
 const tracked = { workHistory: [], ...formErrors, _isValid: false };
 errorTrackerV2.setSectionErrors("section3", tracked);
 return tracked;

  }
  const workHistory = Array.isArray(formData.workHistory)
    ? formData.workHistory
    : [];

  const workHistoryErrors = workHistory.map((work = {}, index) => {
    // console.log(`\n--- Validating Work Entry ${index} ---`);
    // console.log("Full work object:", work);
    //     console.log("currentEmploymentStatus:", work.currentEmploymentStatus);
    //     console.log("nameOfFirm:", work.nameOfFirm);
    //     console.log("from:", work.from);
    //     console.log("to:", work.to);

    const workErrors = {};

    const isEducationOrUnemployed = ["Unemployed", "In Education"].includes(
      work.currentEmploymentStatus,
    );

    // console.log("isEducationOrUnemployed:", isEducationOrUnemployed);

    const requiredFields = isEducationOrUnemployed
      ? ["currentEmploymentStatus", "from", "to", "educationDetails"]
      : [
          "nameOfFirm",
          "natureOfBusiness",
          "addressOfFirm",
          "firmTown",
          "firmCounty",
          "firmPostcode",
          "officeTelephone",
          "emailAddress",
          "from",
          "to",
          "currentIncome",
          "currentJobTitle",
          "FCARegulated",
          "regulatedRole",
          // "appointedRepresentative",
          // "authorisationCommenced",
          "currentRole",
          "currentEmploymentStatus",
          "reasonsForLeaving",
          "contactForReference",
          "lifeAssuranceCompany",
          "reasonForNoReference",
        ];

   requiredFields.forEach((field) => {
     // SPECIAL CASES FIRST
     if (field === "lifeAssuranceCompany") {
       if (
         work.appointedRepresentative === true &&
         isBlank(work.lifeAssuranceCompany)
       ) {
         workErrors[field] = "This field is required";
       }
       return;
     }

     if (field === "reasonForNoReference") {
       if (
         work.contactForReference === false &&
         isBlank(work.reasonForNoReference)
       ) {
         workErrors[field] = "This field is required";
       }
       return;
     }

     if (field === "officeTelephone") {
       if (isBlank(work.officeTelephone)) {
         workErrors[field] = "This field is required";
       }
       return;
     }

     if (field === "contactForReference") {
       if (
         work.contactForReference === null ||
         work.contactForReference === undefined
       ) {
         workErrors[field] = "This field is required";
       }
       return;
     }

     // ✅ GENERIC REQUIRED CHECK (this is what you’re missing)
     if (isBlank(work[field])) {
       workErrors[field] = "This field is required";
     }
   });


    // EXACT: first entry extra required if not unemployed
    const isEmployedOrSelf = ["Employed", "Self-employed"].includes(
      work.currentEmploymentStatus,
    );

   if (index === 0 && isEmployedOrSelf) {
     const firstEntryRequiredFields = [
       "competentAdviser",
       "intendedResignation",
       "noticePeriod",
       "currentJobTitle",
       "currentRole",
       "FCARegulated",
       "regulatedRole",
      //  "appointedRepresentative",
     ];

     firstEntryRequiredFields.forEach((field) => {
       if (field === "noticePeriod") {
         if (
           work[field] === null ||
           work[field] === undefined ||
           work[field] === ""
         ) {
           workErrors[field] = "This field is required";
         }
         return;
       }

       if (
         work[field] === null ||
         work[field] === undefined ||
         (typeof work[field] === "string" && work[field].trim() === "")
       ) {
         workErrors[field] = "This field is required";
       }
     });
   }


    // console.log(`Work Entry ${index} - Errors found:`, workErrors);
    // console.log(
    //   `Work Entry ${index} - Error count:`,
    //   Object.keys(workErrors).length,
    // );

    return workErrors;
  });

  const formIsValid = workHistoryErrors.every(
    (workErr) => Object.keys(workErr).length === 0,
  );

  // errorTrackerV2.setSectionErrors("section3", {
  //   workHistory:
  //     workHistory.length > 0
  //       ? workHistoryErrors
  //       : {
  //           0: { dataNotFound: "No work history entries found." },
  //         },
  // });
  errorTrackerV2.setSectionErrors("section3", {
    workHistory: workHistoryErrors,
    _isValid: formIsValid,
  });


  // console.log("Section 3 validation completed. Errors:", workHistoryErrors);
  // console.log("Section 3 validation completed. Form valid?", formIsValid);

  return {
    workHistory: workHistoryErrors,
    _isValid: formIsValid,
  };
}
